<!-- 秒杀、满减、拼团模块 -->
<template>
	<div class="index-promotion">
		<!-- type 9 秒杀 -->
		<div v-if="proData.type == 9" class="index-product" :style="{backgroundColor:proData.bg_color,padding:proData.list_style=='4'?'0':'20px 3% 0'}">
			<div v-for="(pro,index) in proData.spikes_products" :key="index" v-if="pro">
				<div v-if="proData.list_style == '4'" class="tab-detail" @click="goProductDtl(pro.id,1)">
					<div class="fui-goods-item">
						<div class="goodsImg">
							<el-image
								style="width: 100%;"
								class="product-proImg"
								:src="pro.spikes_info.shop_product.image_url"
								fit="contain">
							</el-image>
							<div class="btn_bg spikeText">
								<div class="spikeInfo">
									<div>{{pro.spikes_info.time_info.istimeTitle}}</div>
									<div v-if="pro.spikes_info.time_info.istime == 2">00:00:00</div>
									<div v-else>
										<span v-for="(item,index) in pro.spikes_info.time_info.spikeTime" :key="index">{{item}}{{index==0?':':''}}{{index==1?':':''}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="detail">
							<div class="product-item">
								{{pro.spikes_info.shop_product.title}}
							</div>
							<div class="index_price price">
								<span>￥{{pro.spikes_info.spike_price}}</span>
								<span class="oldPrice">￥{{pro.spikes_info.shop_product.price}}</span>
								<div class="stockNum">{{pro.spikes_info.quantity}}</div>
							</div>
						</div>
					</div>
				</div>
				<div v-else :class="'tab-detail-'+proData.list_style" @click="goProductDtl(pro.id,1)">
					<div class='product-item'>
						<div class="productImg">
							<el-image
								style="width: 100%;"
								class="product-proImg"
								:src="pro.spikes_info.shop_product.image_url"
								fit="contain">
							</el-image>
							<div class="btn_bg spikeText">
								<div class="spikeInfo">
									<div>{{pro.spikes_info.time_info.istimeTitle}}</div>
									<div v-if="pro.spikes_info.time_info.istime == 2">00:00:00</div>
									<div v-else>
										<span v-for="(item,index) in pro.spikes_info.time_info.spikeTime" :key="index">{{item}}{{index==0?':':''}}{{index==1?':':''}}</span>
									</div>
								</div>
							</div>
						</div>
						<div class="product-info">
							<div class="textline1">
								{{pro.spikes_info.shop_product.title}}
							</div>
							<div>
								<span>￥{{pro.spikes_info.spike_price}}</span>
								<span class="oldPrice">￥{{pro.spikes_info.shop_product.price}}</span>
								<!-- <div class="stockNum"><span>库存</span>{{pro.spikes_info.quantity}}</div> -->
								<div class="stockNum">{{pro.spikes_info.quantity}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- type 10 满减 -->
		<div v-if="proData.type == 10" class="index-product" :style="{backgroundColor:proData.bg_color,padding:proData.list_style=='4'?'0':'20px 3% 0'}">
			<div v-for="(pro,index) in proData.full_discount_products" :key="index" v-if="pro">
				<div v-if="proData.list_style == '4'" class="tab-detail" @click="goProductDtl(pro.id,2)">
					<div class="fui-goods-item">
						<div class="goodsImg">
							<el-image
								style="width: 100%;"
								class="product-proImg"
								:src="pro.full_discount_info.shop_product.image_url"
								fit="contain">
							</el-image>
							<div class="btn_bg spikeText" v-if="pro.full_discount_info.name">
								<div class="spikeInfo">
									<div>{{pro.full_discount_info.name}}</div>
								</div>
							</div>
						</div>
						<div class="detail">
							<div class="product-item">
								{{pro.full_discount_info.shop_product.title}}
							</div>
							<div class="index_price price">
								<span class="text">￥{{pro.full_discount_info.shop_product.sales_price}}</span>
								<span class="oldPrice">￥{{pro.full_discount_info.shop_product.price}}</span>
							</div>
						</div>
					</div>
				</div>
				<div v-else :class="'tab-detail-'+proData.list_style" @click="goProductDtl(pro.id,2)">
					<div class='product-item'>
						<div class="productImg">
							<el-image
								style="width: 100%;"
								class="product-proImg"
								:src="pro.full_discount_info.shop_product.image_url"
								fit="contain">
							</el-image>
							<div class="btn_bg spikeText" v-if="pro.full_discount_info.name">
								<div class="spikeInfo">
									<div>{{pro.full_discount_info.name}}</div>
								</div>
							</div>
						</div>
						<div class="product-info">
							<div class="textline1">
								{{pro.full_discount_info.shop_product.title}}
							</div>
							<div>
								<span>￥{{pro.full_discount_info.shop_product.sales_price}}</span>
								<span class="oldPrice">￥{{pro.full_discount_info.shop_product.price}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- type 11 拼团 -->
		<div v-if="proData.type == 11" class="index-product" :style="{backgroundColor:proData.bg_color,padding:proData.list_style=='4'?'0':'20px 3% 0'}">
			<div v-for="(pro,index) in proData.group_products" :key="index" v-if="pro">
				<div v-if="proData.list_style == '4'" class="tab-detail" @click="goProductDtl(pro.id,3)">
					<div class="fui-goods-item">
						<div class="goodsImg">
							<el-image
								style="width: 100%;"
								class="product-proImg"
								:src="pro.group_info.shop_product.image_url"
								fit="contain">
							</el-image>
						</div>
						<div class="detail">
							<div class="product-item">
								【拼团】 {{pro.group_info.shop_product.title}}
							</div>
							<div class="index_price price">
								<span>￥{{pro.group_info.group_price}}</span>
								<span class="oldPrice">￥{{pro.group_info.shop_product.price}}</span>
								<!-- <div class="stockNum"><span>库存</span>{{pro.group_info.shop_product.stock}}</div> -->
								<!-- <div class="stockNum">{{pro.group_info.shop_product.stock}}</div> -->
							</div>
						</div>
					</div>
				</div>
				<div v-else :class="'tab-detail-'+proData.list_style" @click="goProductDtl(pro.id,3)">
					<div class='product-item'>
						<div class="productImg">
							<el-image
								style="width: 100%;"
								class="product-proImg"
								:src="pro.group_info.shop_product.image_url"
								fit="contain">
							</el-image>
						</div>
						<div class="product-info">
							<div class="textline1">
								【拼团】 {{pro.group_info.shop_product.title}}
							</div>
							<div>
								<span>￥{{pro.group_info.group_price}}</span>
								<span class="oldPrice">￥{{pro.group_info.shop_product.price}}</span>
								<!-- <div class="stockNum"><span>库存</span>{{pro.group_info.shop_product.stock}}</div> -->
								<!-- <div class="stockNum">{{pro.group_info.shop_product.stock}}</div> -->
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name:'promotionProduct',
	props:{
		proData:{
			type:Object,
		},
	},
	methods:{
		goProductDtl(id,type){
			console.log(id);
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/mode/promotionProduct.vue